import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Scrollbar from "../widgets/Scrollbar";
import {
  RelatedArticlesContainer,
  VerTodos,
  DisplayedFileStyle,
  AdjuntarArchivo,
} from "./createRequestElements";
import { Delete } from "../../components/svg/Delete";
import { Adjuntar } from "../../components/svg/Adjuntar";

import Highlighter from "react-highlight-words";
import { useDispatch } from "react-redux";
import { setMode } from "../../store/modules/RuleStore";
import { useTranslation } from "react-i18next";
import { useTranslationContext } from "../../context/TranslationContext";
import TranslatableText from "../Multilanguage/TranslatableText";

import Tooltip from "../../components/widgets/Tooltip";

export const TabFaq = (props) => {
  const { faqs, description } = props;

  const { t } = useTranslation();
  const { translateText, targetLang } = useTranslationContext();

  const [translatedFaq, setTranslatedFaq] = useState([]);

  function html2text(html) {
    var tag = document.createElement("div");
    tag.innerHTML = html;

    return tag.innerText;
  }

  useEffect(() => {
    const translate = async () => {
      const response = await Promise.all(
        faqs.faqsFounded.map(async (data) => {
          const resQuestion = await translateText(data.question, "text");
          return {
            ...data,
            question: resQuestion,
          };
        })
      );
      setTranslatedFaq(response);
    };

    if (targetLang && targetLang !== "es") {
      translate();
    } else {
      setTranslatedFaq(faqs?.faqsFounded);
    }
  }, [faqs.faqsFounded, translateText]);

  return (
    <RelatedArticlesContainer>
      <div className="flex flex-row-reverse">
        <VerTodos to="/faq/all" href="">
          {t("createRequest.buttonViewAll")}
          <span>
            <svg
              className="h-4 "
              viewBox="0 0 11 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 18.5L9.5 10L1.5 1.5"
                stroke="#E5E5E5"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </VerTodos>
      </div>
      <h1 className="font-semibold text-2xl text-azulMedio">
        {t("createRequest.relatedArticles")}
      </h1>
      <p className="my-1 font-bold">{t("createRequest.relatedArticlesDesc")}</p>
      <Scrollbar height="38rem">
        {translatedFaq.map((faq, index) => {
          return (
            <Link to={`/faq/${faq.faqID}`} key={index}>
              <div
                className="bg-white px-8 py-3 rounded-md border border-gris my-2"
                style={{
                  height: "190px",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: "7",
                  WebkitBoxOrient: "vertical",
                }}
              >
                <h4 className="font-semibold text-space">
                  {" "}
                  <TranslatableText text={faq.question} />
                </h4>
                {/* <div className="text-sm font-normal"> */}
                {/* <Highlighter
                    highlightClassName="YourHighlightClass"
                    searchWords={[...subject.split(/\W+/)]}
                    autoEscape={true}
                    textToHighlight={html2text(
                      faq.answer.slice(0, 280) + "<span>...</span>"
                    )}
                  /> */}
                <TranslatableText text={faq.answer} format="html" />
                {/* <div
                  dangerouslySetInnerHTML={{
                    __html: faq.answer,
                  }}
                ></div> */}
                {/* </div> */}
              </div>
            </Link>
          );
        })}
        {faqs.faqsFoundedByDesc.map((faq, index) => {
          return (
            <Link to={`/faq/${faq.faqId}`} key={index}>
              <div className="bg-white px-8 py-3 rounded-md border border-gris my-2">
                <h4 className="font-semibold text-space">{faq.question}</h4>
                <div className="text-sm font-normal">
                  <Highlighter
                    highlightClassName="YourHighlightClass"
                    searchWords={[...html2text(description).split(/\W+/)]}
                    autoEscape={true}
                    textToHighlight={html2text(
                      faq.answer.slice(0, 280) + "<span>...</span>"
                    )}
                  />
                </div>
              </div>
            </Link>
          );
        })}
      </Scrollbar>
    </RelatedArticlesContainer>
  );
};

export const TabRule = (props) => {
  const {
    rules,
    areaSelected,
    serviceSelected,
    setButtonActive,
    setRuleSelected,
    ruleSelected,
    handleAreaChange,
    handleServiceChange,
    requestState,
    handleCancelRulesChoice,
    clearRules,
  } = props;

  const dispatch = useDispatch();

  const { t } = useTranslation();
    const {  targetLang } = useTranslationContext();

  return (
    <>
      <div className="flex justify-between">
        <h1 className="font-semibold text-3xl my-4">
          {rules.mode === 2 ? t("createRequest.rules") : ""}
          {rules.mode === 3 ? t("createRequest.completeInfo") : ""}
        </h1>
      </div>
      {/* {rules.mode === 2 ? (
        <div className="mt-4 flex flex-col">
          <div className="border border-dotted flex justify-between items-center border-gray-400 p-3 mb-2">
            <p>
              Regla Seleccionada:{" "}
              <span className="font-semibold">
                {ruleSelected.name !== "" ? ruleSelected.name : "Ninguna"}
              </span>
            </p>
            <button
              className="border border-red-700 px-2 py-0 text-red-700 rounded-md hover:text-black hover:border-black"
              onClick={(e) => {
                setButtonActive(false);
                setRuleSelected({ id: "", name: "" });
              }}
            >
              X
            </button>
          </div>
        </div>
      ) : (
        <></>
      )} */}
      {rules.mode === 3 ? (
        <div>
          <div>
            <p className="font-medium p-1">{t("createRequest.labelArea")}:</p>
            <Select
              className=" rounded-md p-1 w-full focus:border-blue-400 z-10"
              defaultValue={areaSelected}
              onChange={(e) => handleAreaChange(e)}
              options={requestState.areas.map((data) => {
                return {...data, label: targetLang !== "es" ? <TranslatableText text={data.label} /> : data.label }
              })}
            />
          </div>
          <div>
            <p className="font-medium p-1">
              {t("createRequest.labelService")}:
            </p>
            <Select
              className=" rounded-md p-1 w-full focus:border-blue-400 z-0"
              value={serviceSelected}
              onChange={(e) => handleServiceChange(e)}
              options={requestState.services.map((data) => {
                return {
                  ...data,
                  label: targetLang !== "es" ? <TranslatableText text={data.label} /> : data.label,
                };
              })}
            />
          </div>
          <div className="flex items-center justify-center mt-6">
            <button
              className="bg-white rounded-md px-3 text-blue-600  font-semibold border border-blue-600 hover:text-white hover:bg-blue-600 hover:border-white"
              onClick={() => {
                handleCancelRulesChoice();
                clearRules();
              }}
            >
              {t("cancelButton")}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {rules.mode === 2 ? (
        <>
          <div className="mt-4 flex flex-col">
            <div className="border border-dotted flex justify-between items-center border-gray-400 p-3 mb-2">
              <p>
                {t("createRequest.selectedRule")}:{" "}
                <span className="font-semibold">
                  {ruleSelected.name !== ""
                    ? <TranslatableText text={ruleSelected.name} />
                    : t("createRequest.noneRule")}
                </span>
              </p>
              <button
                className="border border-red-700 px-2 py-0 text-red-700 rounded-md hover:text-black hover:border-black"
                onClick={(e) => {
                  setButtonActive(false);
                  setRuleSelected({ id: "", name: "" });
                }}
              >
                X
              </button>
            </div>
          </div>
          <div className="mt-2 flex flex-col h-xl  overflow-y-scroll">
            {rules.list.map((rule, index) => {
              return (
                <div
                  className="bg-white p-2 my-2 flex justify-between items-center"
                  key={index}
                >
                  <h4 className="font-semibold"><TranslatableText text={rule.ruleName} /></h4>
                  <button
                    className="bg-blue-700 px-2 py-1 rounded-md font-semibold text-white border hover:border-blue-700 hover:bg-white hover:text-blue-700"
                    onClick={(e) => {
                      e.preventDefault();
                      setButtonActive(true);

                      setRuleSelected({
                        id: rule.ruleID,
                        name: rule.ruleName,
                      });
                    }}
                  >
                    {t("selectButton")}
                  </button>
                </div>
              );
            })}
          </div>
          <div className="flex items-center justify-center mt-8">
            <button
              className="  bg-white rounded-md px-3 text-blue-600  font-semibold border border-blue-600 hover:text-white hover:bg-blue-600 hover:border-white"
              type="button"
              onClick={(e) => {
                dispatch(setMode(3));
              }}
            >
              {t("cancelButton")}
            </button>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export const DisplayedFile = (props) => {
    const truncateMiddle = (text: string, startLength = 10, endLength = 5) => {
    if (text.length <= startLength + endLength) return text;
    return text.slice(0, startLength) + "..." + text.slice(-endLength);
  };
  const [hover, setHover] = useState(false);
  const { singleFile, setFiles, files } = props;

  return (
    <DisplayedFileStyle className="relative">
      <Tooltip title={`${singleFile.name}`}>
        <span className="file-name">
          {singleFile.name.length > 25
            ? truncateMiddle(singleFile.name)
            : singleFile.name}
        </span>
      </Tooltip>
      <span
        className="delete-icon"
        onClick={() => {
          setFiles(files.filter((item) => item.name !== singleFile.name));
        }}
        onMouseOver={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <Delete hover={hover} />
      </span>
    </DisplayedFileStyle>
  );
};


export const FilePaste = ({ files, setFiles, handleChange }) => {
  const { t } = useTranslation();

  const handlePaste = (e) => {
    if (e.clipboardData.files.length) {
      const fileObject = e.clipboardData.files[0];

      setFiles([...files, fileObject]);
    } else {
      alert(
        "No image data was found in your clipboard. Copy an image first or take a screenshot."
      );
    }
  };

  return (
    <div onPaste={handlePaste}>
      <div className="flex flex-row gap-2 text-md">
        <AdjuntarArchivo>
          <span className="flex items-center justify-center">
            <Adjuntar />
          </span>
          {t("createRequest.attachFile")}
          <input
            type="file"
            multiple
            autoupload={`false`}
            batch={`false`}
            style={{ display: "none" }}
            name="adjunto"
            className="hidden"
            onChange={(e) => {
              if (e.target.files !== null) {
                handleChange(e.target.files);
              }
            }}
          />
        </AdjuntarArchivo>
        <span className="flex items-center justify-center text-gray-400 no-underline">
          {t("createRequest.maxFileSize")}
        </span>
      </div>
      <div
        style={{
          marginTop: 5,
          padding: 10,
          fontStyle: "italic",
          color: "gray",
          border: "1px solid lightgray",
          borderRadius: "7px",
          height: 100,
        }}
      >
        Paste Area
      </div>
    </div>
  );
};
